// @flow
// $FlowFixMe
import React, { Fragment } from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { Paragraph } from '@finect/tabular-core/Paragraph';
import { Small } from '@finect/tabular-core/Small';
import { AppLink } from '@finect/tabular-core/AppLink';
import { finectAPI } from '@finect/front-utils/finectAPI';
import { modelize } from '@finect/front-utils/modelize';
import { slugify } from '@finect/front-utils/slugify';
import type { QuestionType, TagType } from '../../types';
import { models } from '../../utils';
import { ShowMore, SideTitle } from '../';
import { Related } from './Related';

export const RelatedQuestionList = styled.ul`
  position: relative;
`;

const RelatedQuestion = styled.li`
  padding-bottom: 12px;
  line-height: 1.4em;

  &:not(:last-child) {
    border-bottom: 1px solid ${({ theme }) => theme.borderColorL};
    margin-bottom: 12px;
  }
`;

const ViewMore = styled(ShowMore)`
  color: ${({ theme }) => theme.colors.fontL};

  &:hover {
    color: ${({ theme }) => theme.mainColor};
  }
`;

type Props = {
  title?: string,
  ignoreId?: number | string,
  hide?: string,
  tag: TagType,
  register?: Function
};

type State = {
  questions: Array<QuestionType>
};

export class RelatedQuestions extends React.Component<Props, State> {
  state = {
    questions: []
  };

  getQuestions = (tagID?: number | string) =>
    finectAPI({
      version: 'v3',
      path: `questions?type=active${tagID ? `&tag=${tagID}` : ''}`,
      method: 'GET',
      onSuccess: (questions) => {
        if (questions.list.length <= 1) return this.getQuestions();
        return questions;
      }
    });

  componentDidMount() {
    const { tag, ignoreId, register } = this.props;

    this.getQuestions(tag.id).then((questions) => {
      if (questions.list.length <= 1) return;
      const questionList = ignoreId ? questions.list.slice(0, 6) : questions.list.slice(0, 5);
      const modelizedQuestions = modelize(questionList, models.questions);
      this.setState({ questions: modelizedQuestions });
      register && register(questionList, ignoreId);
    });
  }

  render() {
    const { tag, title, ignoreId, hide } = this.props;
    const { questions } = this.state;
    const relatedQuestions = ignoreId ? questions.filter(question => question.id !== ignoreId) : questions;

    return (
      <Fragment>
        {relatedQuestions.length ? (
          <Related hide={hide}>
            {title ? <SideTitle extraMargin>{title}</SideTitle> : null}

            <RelatedQuestionList>
              {relatedQuestions.map(question => (
                <RelatedQuestion key={question.id}>
                  <Small compact>
                    <AppLink as={Link} to={`/preguntas/${question.id}/${slugify(question.title)}`} rel="nofollow">
                      {question.title}
                    </AppLink>
                  </Small>
                </RelatedQuestion>
              ))}
            </RelatedQuestionList>
            {!ignoreId ? (
              <Paragraph textCenter>
                <ViewMore as={Link} to={`/preguntas/temas/${tag.id}/${slugify(tag.name)}`} rel="nofollow">
                  <Small>Ver más preguntas</Small>
                </ViewMore>
              </Paragraph>
            ) : null}
          </Related>
        ) : null}
      </Fragment>
    );
  }
}
